import React, { createContext, useContext, useEffect, useState } from 'react';

interface ThemeContextType {
  accentColor: string;
  setAccentColor: (color: string) => void;
}

const DEFAULT_ACCENT = '239 84% 67%'; // Default purple

const ThemeContext = createContext<ThemeContextType>({
  accentColor: DEFAULT_ACCENT,
  setAccentColor: () => {},
});

export const useTheme = () => useContext(ThemeContext);

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const [accentColor, setAccentColor] = useState(DEFAULT_ACCENT);

  useEffect(() => {
    // Apply the accent color to CSS variables
    document.documentElement.style.setProperty('--tmw-accent', accentColor);
  }, [accentColor]);

  return (
    <ThemeContext.Provider value={{ accentColor, setAccentColor }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Preset accent colors (HSL format without hsl() wrapper)
export const ACCENT_COLORS = [
  { name: 'Purple', value: '239 84% 67%' },
  { name: 'Blue', value: '217 91% 60%' },
  { name: 'Green', value: '142 71% 45%' },
  { name: 'Orange', value: '25 95% 53%' },
  { name: 'Pink', value: '330 81% 60%' },
  { name: 'Red', value: '0 84% 60%' },
  { name: 'Teal', value: '175 77% 40%' },
  { name: 'Yellow', value: '45 93% 47%' },
];
